import { toast } from "react-toastify";
import api from "../../services/api";
import type {
  IGetHospitalNotificationResponse,
  IGetHospitalsResponse,
  IGetUserHospitalListResponse,
  IHospital,
  IHospitalListResponse,
  IHospitalNotification,
} from "./types";
import type { Dispatch, SetStateAction } from "react";

export function createHospitalUtils() {
  return {
    async getUserHospitalList(): Promise<
      IGetUserHospitalListResponse | undefined
    > {
      try {
        const { data } = await api.get<IGetUserHospitalListResponse>(
          "/user/hospitals/list",
        );
        return data;
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      }
    },

    async getHospitalsList(): Promise<IHospital[] | undefined> {
      try {
        const { data } = await api.get<IHospital[]>("/hospitals/list");
        return data;
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      }
    },

    async getHospitals(
      setHospitalsList?: Dispatch<SetStateAction<IHospital[]>>,
    ): Promise<IGetHospitalsResponse | undefined> {
      try {
        const response = await api.get<IGetHospitalsResponse>(
          "/list/procedencia",
        );
        if (setHospitalsList) {
          setHospitalsList(response.data.Hospitals);
        }
        return response.data;
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      }
    },

    // async createUserByHospital(data: any, getUsers: () => void) {
    //     try {
    //         const response = await api.post("/hospital/user/store", data);
    //         if (response?.data?.message) {
    //             toast.success(response?.data?.message);
    //         }
    //         await getUsers();
    //         return response;
    //     } catch (error: any) {
    //         if (error?.response?.data?.message) {
    //             toast.error(error?.response?.data?.message);
    //         }
    //         return error;
    //     }
    // },

    async listHospital(grupo_id: string): Promise<any> {
      try {
        const response = await api.get<any>(`list/hospitals/group/${grupo_id}`);
        return response?.data;
      } catch (error: any) {
        return error;
      }
    },

    async EditImageHospital(data: FormData) {
      const response = await api.post(`/upload/hospital/image`, data);
      return response;
    },

    async ShowHospitalsForId(grupo_id: string) {
      try {
        const response = await api.get(`/show/hospitals/${grupo_id}`);
        return response?.data;
      } catch (error) {
        return error;
      }
    },

    async EditHospital(hospital_id: string, data: any) {
      try {
        const response = await api.put(`/hospital/${hospital_id}`, data);
        if (response?.data?.message) {
          toast.success(response?.data?.message);
        }
      } catch (error: any) {
        if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        }
        return error;
      }
    },

    async hospitalList(
      grupo_id: string,
    ): Promise<IHospitalListResponse | undefined> {
      try {
        const response = await api.get<IHospitalListResponse>(
          `hospital/user/list/${grupo_id}`,
        );
        return response?.data;
      } catch (error: any) {
        return error;
      }
    },

    async getHospitalNotification(
      uuid: string,
    ): Promise<IHospitalNotification[] | undefined> {
      try {
        const response = await api.get<IGetHospitalNotificationResponse>(
          `list/notifications/${uuid}`,
        );
        return response?.data?.message;
      } catch (error: any) {
        return error;
      }
    },
  };
}
